import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { Role, RoleModel } from '@app/_models';
import { catchError, finalize, map, tap } from 'rxjs/operators';

const baseUrl = `${environment.apiUrl}/roles`;

@Injectable({ providedIn: 'root' })
export class RoleService {
    
    private roleSubject: BehaviorSubject<RoleModel>;
    public role: Observable<RoleModel>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.roleSubject = new BehaviorSubject<RoleModel>(null);
        this.role = this.roleSubject.asObservable();
    }

    public get roleValue(): RoleModel {
        return this.roleSubject.value;
    }

    getAll() {
        return this.http.get<RoleModel[]>(baseUrl);
    }

    getAssignedRoles(id: string): Observable<RoleModel[]> {
        return this.http.get<RoleModel[]>(`${baseUrl}/${id}`).pipe(
            tap(),
            catchError(() => { console.error('Error. No roles assigned.'); return of([]); }),
            finalize(() => console.log('assigned roles fetched'))           
        );
    }

    create(params) {
        return this.http.post(baseUrl, params);
    }

    update(id, params) {
        return this.http.put(`${baseUrl}/${id}`, params);
            // .pipe(map((role: any) => {
            //     // update the current role if it was updated
            //     if (role.id === this.roleValue.id) {
            //         // publish updated role to subscribers
            //         role = { ...this.roleValue, ...role };
            //         this.roleSubject.next(role);
            //     }
            //     return role;
            // }));
    }

    delete(id: string) {
        return this.http.delete(`${baseUrl}/${id}`)
            .pipe(finalize(() => { /* no-op */ }));
    }
}